import { Paper } from '@mantine/core';

import { MarkdownSkeleton } from '#core/components/dashboard/panels/markdown/MarkdownSkeleton.tsx';
import { MarkdownSchema } from '#core/components/dashboard/panels/markdown/schema.ts';
import { MarkdownRenderer } from '#core/components/shared/MarkdownRenderer.tsx';

import { createGridComponent } from '../shared/helpers.ts';
import classes from './Markdown.module.css';

/**
 * Pure Markdown component for dashboard grid.
 *
 * Displays formatted markdown text content using react-markdown with
 * GitHub Flavored Markdown support (tables, strikethrough, task lists).
 * This is a pure renderer - receives all data as props, no internal data fetching.
 * Works in both dashboard grid and chat block contexts.
 */
export const Markdown = createGridComponent(
  ({ content }) => (
    <Paper className={classes.markdown} p="md" radius="sm" withBorder>
      <MarkdownRenderer className={classes.markdownContent} content={content} />
    </Paper>
  ),
  MarkdownSchema,
  MarkdownSkeleton,
);
